<template lang="html">
  <v-layout row>
    <v-layout column class="event">
      <chat-user-header :main-icon="mainIcon"
                        :event="event"
                        :participants="participants">
        uploaded a file
      </chat-user-header>
      <v-flex xs12 sm12 class="text-xs-left event-line ml-1" align-center>
        <v-layout align-center fill-height wrap>
          <span class="pl-4 font-weight-light">
            {{event.message}}
          </span>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm2 v-if="showTime"
              class="text-sm-right text-sm-left event-line font-weight-light caption pr-2">
        <span>{{event.timestamp | formatDate}}</span>
      </v-flex>
    </v-layout>
    <div class="event-media">
      <a @click="openAttachment(media.link)">
        <img :src="getAttachmentUrl(media.link)" height="40"
             width="40" :id="`event-img-${media.link}`" v-if="isImage"/>
        <icon-base width="40" height="40" icon-name="pdf" viewBox="0 0 32 32"
                   icon-color="black"
          v-if="isPdfAttachment"
        >
          <icon-pdf />
        </icon-base>
      </a>
    </div>
  </v-layout>
</template>

<script>
import _ from 'lodash';
import API from '@/api';
import IconBase from '@/components/IconBase';
import IconPdf from '@/components/icons/IconPDF';
import ChatUserHeader from './ChatUserHeader';

export default {
  name: 'UserMediaUploadEvent',
  components: {
    IconBase,
    IconPdf,
    ChatUserHeader,
  },
  props: {
    event: {
      required: true,
      type: Object,
    },
    participants: {
      required: true,
      type: Array,
    },
    showTime: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    mainIcon() {
      return this.isImage ? 'image' : 'attachment';
    },
    media() {
      return _.get(this.event, 'mediaMessage', {});
    },
    isPdfAttachment() {
      return !this.media.image && this.media.mimeType === 'application/pdf';
    },
    isImage() {
      const contentType = this.media.mimeType;
      return contentType.toLocaleLowerCase().startsWith('image');
    },
  },
  created() {
    if (this.media.image) {
      this.getAttachmentUrl();
    }
  },
  methods: {
    async openAttachment(url) {
      this.$store.dispatch('lightbox/show', url);
    },
    async getAttachmentUrl() {
      const response = await API.application.getDocument({ url: this.media.link });
      const url = window.URL.createObjectURL(response);
      document.getElementById(`event-img-${this.media.link}`).src = url;
    },
  },
};
</script>
<style lang="css" scoped>
  .event {
    border-left: 3px #d2d2d2 solid;
  }
  .event-media {
    border-radius: 2px;
    margin-right: 5px;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/timeline/UserMediaUploadEvent.vue